type VehicleLabelInput = {
  year?: string | number | null
  make?: string | null
  model?: string | null
  engineDisplacementL?: string | number | null
  engineCylinders?: string | number | null
  engineType?: string | null
  engineCode?: string | null
  engineDescription?: string | null
}

function normalizePart(value: unknown): string {
  if (value === null || value === undefined) return ''
  if (typeof value === 'number') return Number.isFinite(value) ? String(value) : ''
  if (typeof value === 'string') return value.trim()
  return ''
}

function formatDisplacementL(value: unknown): string {
  if (value === null || value === undefined) return ''
  const parsed = Number.parseFloat(String(value))
  if (!Number.isFinite(parsed) || parsed <= 0) return ''
  return `${parsed.toFixed(1)}L`
}

function formatCylinders(value: unknown): string {
  if (value === null || value === undefined) return ''
  const parsed = Number.parseInt(String(value), 10)
  if (!Number.isFinite(parsed) || parsed <= 0) return ''
  return `${parsed}Cyl`
}

function parseDisplacementFromDescription(value: unknown): string {
  const text = normalizePart(value)
  if (!text) return ''
  const match = text.match(/\b(\d+(?:\.\d+)?)\s*L\b/i)
  if (!match) return ''
  return formatDisplacementL(match[1])
}

function parseCylindersFromDescription(value: unknown): string {
  const text = normalizePart(value)
  if (!text) return ''
  const match = text.match(/\b(\d{1,2})\s*(?:cyl|cylinders?)\b/i)
  if (!match) return ''
  return formatCylinders(match[1])
}

function parseEngineCodeFromDescription(value: unknown): string {
  const text = normalizePart(value)
  if (!text) return ''
  const match = text.match(/\b[A-Z0-9]{2,}(?:-[A-Z0-9]+)+\b/i)
  return match ? match[0] : ''
}

export function formatVehicleLabel(
  vehicle: VehicleLabelInput | null | undefined,
  fallback = 'Vehicle'
): string {
  if (!vehicle) return fallback

  const baseLabel = [vehicle.year, vehicle.make, vehicle.model]
    .map(normalizePart)
    .filter(Boolean)
    .join(' ')
    .trim()

  if (!baseLabel) return fallback

  const displacement =
    formatDisplacementL(vehicle.engineDisplacementL) ||
    parseDisplacementFromDescription(vehicle.engineDescription)
  const cylinders =
    formatCylinders(vehicle.engineCylinders) ||
    parseCylindersFromDescription(vehicle.engineDescription)
  const engineType = normalizePart(vehicle.engineType)
  const engineCode = normalizePart(vehicle.engineCode) || parseEngineCodeFromDescription(vehicle.engineDescription)

  const engineParts = [displacement, cylinders || engineType].filter(Boolean).join(' ').trim()
  const engineSuffix = engineCode
    ? engineParts
      ? `${engineParts} (${engineCode})`
      : engineCode
    : engineParts

  return engineSuffix ? `${baseLabel} ${engineSuffix}` : baseLabel
}
